import { Box, Grid, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'

type GridItemProps = {
  children: React.ReactNode
  heading: string
  icon: string
}

const GridItem = ({ children, heading, icon }: GridItemProps) => (
  <Box textAlign="left">
    <CloudflareImage src={`/images/icon/${icon}.svg`} width="72" height="72" />
    <Typography variant="h6" component="h2">
      {heading}
    </Typography>
    <Typography variant="p3">{children}</Typography>
  </Box>
)

type VirtualMailHowItWorksProps = {
  items: { content: string; heading: string; icon: string }[]
}

const VirtualMailHowItWorks = ({ items }: VirtualMailHowItWorksProps) => {
  return (
    <>
      <Typography variant="h3">How it works</Typography>
      <Grid
        container
        justifyContent={{ md: 'center', xs: 'left' }}
        /* eslint-disable sort-keys */
        spacing={{
          xs: 4,
          md: 8,
        }}
        /* eslint-disable sort-keys */
      >
        {items.map(({ heading, content, icon }) => (
          <Grid item md={3} key={heading}>
            <GridItem heading={heading} icon={icon}>
              {content}
            </GridItem>
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default VirtualMailHowItWorks
